import { Validate } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../../translations';
import {
   MedicalDataAccessAuthorizationFormBean,
   MedicalDataAccessAuthorizationFormController,
} from '../MedicalDataAccessAuthorizationModalForm.types';

type RepeatNewPasswordProps = {
   readonly register: MedicalDataAccessAuthorizationFormController['register'];
};

const validate: Validate<MedicalDataAccessAuthorizationFormBean> = (data, getValue) => {
   return Boolean(data || getValue('documentationAccess'));
};

const InformationAccessField = (props: RepeatNewPasswordProps): JSX.Element => {
   return (
      <Checkbox
         label={patientConsentsAndAuthorizationsTranslationKeys.authorizations.informationAccess}
         controller={props.register('informationAccess', { validate: validate })}
         testId={'informationAccess'}
      />
   );
};

export { InformationAccessField };
